// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loanSubmissionDialog .el-dialog__body{padding:1.5rem 1.25rem}.loanSubmissionDialog .title{color:#303030!important}.loanSubmissionDialog .el-dialog__header{padding:0!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
